import React, { useEffect, useState } from 'react';
import { useApp } from '../context/AppContext';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import SpotDetailsModal from '../components/Modals/SpotDetailsModal';

function SpotDetailsPage() {
  const { state, actions } = useApp();
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [spot, setSpot] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSpot = async () => {
      try {
        // Charger le spot depuis l'API
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/spots/${id}`);
        if (response.ok) {
          const spotData = await response.json();
          setSpot(spotData);
          actions.setSelectedSpot(spotData);
          
          // Ouvrir automatiquement la modale si details=true
          if (searchParams.get('details') === 'true') {
            actions.setShowSpotDetails(true);
          }
        } else {
          // Spot non trouvé, rediriger
          navigate('/');
        }
      } catch (error) {
        console.error('Error loading spot:', error);
        navigate('/');
      } finally {
        setLoading(false);
      }
    };

    loadSpot();
  }, [id, searchParams, actions, navigate]);

  const handleCloseModal = () => {
    actions.setShowSpotDetails(false);
    navigate('/');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <div className="text-gray-500">Chargement du spot...</div>
        </div>
      </div>
    );
  }

  if (!spot) {
    return null;
  }

  return (
    <>
      {/* Modal de détails */}
      <SpotDetailsModal 
        isOpen={state.showSpotDetails} 
        onClose={handleCloseModal}
      />
      
      {/* Page de fallback si la modale ne s'ouvre pas */}
      {!state.showSpotDetails && (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-800 mb-4">{spot.title}</h1>
            <button
              onClick={() => actions.setShowSpotDetails(true)}
              className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Voir les détails
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default SpotDetailsPage;
